import { useLanguage } from "@/i18n/LanguageContext";
import { SectionHeading } from "@/components/SectionHeading";
import { FadeUp } from "@/components/motion/Reveal";

export function Services() {
  const { t } = useLanguage();

  return (
    <section id="leistungen" data-testid="services-section" className="blueprint-grid bg-[#FAFAFA] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          index={t.sections.services.index}
          label={t.sections.services.label}
          title={t.sections.services.title}
          sub={t.sections.services.sub}
        />

        <div className="grid gap-px border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {t.services.map((s, i) => (
            <FadeUp key={i} delay={(i % 3) * 0.07} className="h-full">
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative flex h-full items-start gap-5 bg-white p-6 transition-colors duration-300 hover:bg-navy md:p-7"
              >
                <span className="pt-1 font-mono text-xs font-medium text-brand">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-base font-bold leading-snug tracking-tight text-navy transition-colors duration-300 group-hover:text-white md:text-lg">
                  {s.title}
                </h3>
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-brand transition-all duration-500 group-hover:w-full" />
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
